import React, { useEffect, useState } from 'react';

import { INavigation } from '../../shared/types/catalog';

import './Breadcrumbs.sass';
import { BreadcrumbsItem } from './BreadcrumbsItem';
import { getBreadcrumbs } from './utils';

interface IBreadcrumbsProps {
  navigation: INavigation[];
}

// Хлебные крошки
export const Breadcrumbs: React.FC<IBreadcrumbsProps> = ({ navigation }) => {
  const [content, setContent] = useState<INavigation[]>([]);
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const data = getBreadcrumbs(window.innerWidth, navigation);
      setContent(data);
      if (
        JSON.stringify(data) !==
        JSON.stringify(navigation?.slice(1, navigation.length))
      ) {
        setShowMore(true);
      } else {
        setShowMore(false);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [navigation]);

  const handleShowMore = () => {
    setShowMore(false);
  };

  return (
    <div className="breadcrumbs">
      <div className="breadcrumbs__item--red">Главная</div>
      <div className="breadcrumbs__item--gray">/</div>
      <div className="breadcrumbs__item--red">{navigation?.[0]?.title}</div>
      {showMore && (
        <>
          <div className="breadcrumbs__item--gray">/</div>{' '}
          <div className="show-more" onClick={handleShowMore}>
            <div className="show-more--bullet"></div>
            <div className="show-more--bullet"></div>
            <div className="show-more--bullet"></div>
          </div>
        </>
      )}
      {showMore
        ? content.map((item, index, array) => (
            <BreadcrumbsItem
              key={item.id}
              item={item}
              arrayLength={array.length}
              index={index}
              catalogType={navigation?.[0]?.slug}
            />
          ))
        : navigation
            ?.filter((item, index) => index !== 0)
            .map((item, index, array) => (
              <BreadcrumbsItem
                key={item.id}
                item={item}
                arrayLength={array.length}
                index={index}
                catalogType={navigation?.[0]?.slug}
              />
            ))}
    </div>
  );
};
